import { useContext, createContext } from 'react';
import { RootStoreModel } from '@src/mobx/stores/Root';

const StoreContext = createContext<RootStoreModel>({} as RootStoreModel);

export const useStore = () => useContext(StoreContext);

export default StoreContext.Provider;
